module.exports = __webpack_public_path__ + "static/img/image081.232f332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image081.png
// module id = Gezs
// module chunks = 1